export const CRM_OBJECT = 'CRM_OBJECT';